import { render, staticRenderFns } from "./NewAddressBookEntry.vue?vue&type=template&id=560ae27e&scoped=true&"
import script from "./NewAddressBookEntry.vue?vue&type=script&lang=js&"
export * from "./NewAddressBookEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560ae27e",
  null
  
)

export default component.exports